// extracted by mini-css-extract-plugin
export default {"paginationInfo":"styles_paginationInfo__8tIk7"};